import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";

const drawerWidth = 240;

const openedMixin = (theme) => ({
	width: drawerWidth,
	backgroundColor: theme.palette.primary.dark,
	color: "#fff",
	borderRight: `1px solid ${theme.palette.primary.dark}`,
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: "hidden",
});

const closedMixin = (theme) => ({
	backgroundColor: theme.palette.primary.dark,
	color: "#fff",
	borderRight: `1px solid ${theme.palette.primary.dark}`,
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: "hidden",
	width: `calc(${theme.spacing(7)} + 1px)`,

	[theme.breakpoints.up("sm")]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

export const DrawerHeaderLeft = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	padding: theme.spacing(0, 1.5),
	minHeight: 64,
	...theme.mixins.toolbar,
}));

export const DrawerHeaderRight = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "flex-start",
	padding: theme.spacing(0, 1.5),
	minHeight: 64,
	...theme.mixins.toolbar,
}));

export const AppBar = styled(MuiAppBar, {
	shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, left, right }) => ({
	zIndex: theme.zIndex.drawer + 1,

	transition: theme.transitions.create(["width", "margin"], {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.leavingScreen,
	}),

	...(open && {
		marginLeft: left,
		marginRight: right,

		width: `calc(100% - (${left}px + ${right}px))`,

		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	}),
}));

export const Drawer = styled(MuiDrawer, {
	shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: "nowrap",
	boxSizing: "border-box",

	...(open && {
		...openedMixin(theme),

		"& .MuiDrawer-paper": openedMixin(theme),
	}),

	...(!open && {
		...closedMixin(theme),

		"& .MuiDrawer-paper": closedMixin(theme),
	}),
}));
